import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import InvestmentPagePlan from "../../components/investementPagePlan/investmentPagePlan";
import OurPlan from "../../components/OurPlan/ourPlan";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { firestore } from "../../db/config";
import ChoosePlan from "./choosePlan";

export default function Deposit() {
  const dispatch = useDispatch();
  useEffect(() => {
    const getRef = firestore.collection("investmentPlan").get();
    getRef.then((plans) => {
      const getPlans = plans.docs.map((data) => data.data());

      dispatch({ type: "investment_details", data: getPlans });
    });
  });
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>Make Deposit</h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li> Make Deposit</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />

        <ChoosePlan />
      </div>
    </div>
  );
}
